import * as types from '../constants';

export const setPageLanguage = language => ({
  type: types.SET_PAGE_LANGUAGE,
  payload: language,
});
